import HttpRequest from '@/libs/axios';
import config from '@/config2';
console.log('HttpRequest1...', HttpRequest);
var baseUrl = process.env.NODE_ENV === 'development' ? config.baseUrl.dev : process.env.VUE_APP_BUILD === 'production' ? config.baseUrl.pro : config.baseUrl.alp;
var axios = new HttpRequest(baseUrl);
export default axios;